import StorageService from 'services/StorageService';

const parser = ({
  profile,
  organization_roles,
  organization,
  groups,
  is_asset_owner,
  is_delegated,
  can_manage_processing_activities,
  ...rest
}) => {
  const { email, first_name, last_name } = profile;
  return {
    ...rest,
    email,
    first_name,
    last_name,
    roles: organization_roles.map(({ role }) => Number(role)),
    organization: organization?.id || organization,
    ps_roles: groups.map(({ name }) => name),
    is_asset_owner: is_asset_owner ?? false,
    is_delegated: is_delegated ?? false,
    ...(can_manage_processing_activities !== undefined ? { can_manage_processing_activities } : {}),
  };
};

const userDataStorage = new StorageService(process.env.REACT_APP_USER_DATA_NAME, { parser, storage: 'sessionStorage' });

export default userDataStorage;
